var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "not-authorised" },
    [
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c("v-col", { attrs: { md: "12", xs: "12" } }, [
                _c(
                  "h2",
                  { staticClass: "text-center", attrs: { color: "primary" } },
                  [_vm._v("Not Authorised")]
                ),
                _c(
                  "p",
                  { staticClass: "text-center", attrs: { color: "primary" } },
                  [
                    _vm._v(
                      "You have not been given the relevant permissions by a User Administrator for this activity."
                    ),
                  ]
                ),
                _c(
                  "p",
                  { staticClass: "text-center", attrs: { color: "primary" } },
                  [_vm._v("Please contact a User Admin.")]
                ),
                _c(
                  "p",
                  { staticClass: "text-center", attrs: { color: "primary" } },
                  [
                    _vm._v(
                      "You can logout and login again using the top right menu to logout and then the home link to attempt a login again."
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }